import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ConfigProvider } from '@/lib/ConfigContext';
import { LanguageProvider } from '@/lib/LanguageContext';
import { loadB2cConfig } from '@/lib/configLoader';
import ConfigErrorFallback from '@/components/configError/ConfigErrorFallback';
import useConfig from '@/hooks/useConfig';
import { Loader2 } from 'lucide-react';
/**
 * Внутренний компонент, который управляет загрузкой конфига
 */
const ConfigLoader = ({ children }) => {
    const { loadConfig, resetConfig, isLoading, error, isReady, config } = useConfig();
    useEffect(() => {
        // Загружаем конфиг при монтировании компонента
        loadConfig();
    }, [loadConfig]);
    // Показываем загрузку, пока конфиг не получен
    if (isLoading || !isReady) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-screen", children: _jsx("div", { className: "flex flex-col items-center text-center", children: _jsx(Loader2, { className: "size-8 stroke-1 animate-spin" }) }) }));
    }
    // Показываем ошибку, если не удалось загрузить конфиг
    if (error) {
        return (_jsx(ConfigErrorFallback, { error: error, onRetry: () => {
                resetConfig();
                loadConfig();
            } }));
    }
    // Отображаем дочерние компоненты только после успешной загрузки конфига
    // Оборачиваем в LanguageProvider для доступа к системе языков
    return (_jsx(LanguageProvider, { children: children }));
};
/**
 * Основной компонент ConfigReceiver
 * Обеспечивает загрузку конфига перед рендерингом приложения
 */
export const ConfigReceiver = ({ children }) => {
    return (_jsx(ConfigProvider, { loadConfigFn: loadB2cConfig, children: _jsx(ConfigLoader, { children: children }) }));
};
export default ConfigReceiver;
